import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { DistribucionRendimientos} from './DistribucionRendimientos.component';
import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'DistribucionRendimientos',
        component: DistribucionRendimientos,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'DistribucionRendimientos'
        } 
    }
];

@NgModule({
    declarations: [
        DistribucionRendimientos
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        DistribucionRendimientos
    ],
    bootstrap: [DistribucionRendimientos]
})

export class DistribucionRendimientosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DistribucionRendimientos/DistribucionRendimientos.module.ts